var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplianceEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_ce_002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.8L2.5 14.2C2.5 14.2 6.0 17.8 9.0 19.2L9.0 9.8C9.0 9.8 5.8 8.1 2.5 4.8Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.8L15.5 14.2C15.5 14.2 12.0 17.8 9.0 19.2L9.0 9.8C9.0 9.8 12.2 8.1 15.5 4.8Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.8C4.8 2.6 7.0 1.2 9.0 0.5C11.0 1.2 13.2 2.6 15.5 4.8L9.0 8.2L2.5 4.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0 19.45C8.96 19.45 8.92 19.44 8.89 19.42C5.8 17.98 2.26 14.35 2.22 14.31C2.19 14.28 2.18 14.25 2.18 14.21V4.8C2.18 4.76 2.2 4.72 2.23 4.7C4.55 2.47 6.8 1.02 8.88 0.34C8.96 0.31 9.04 0.31 9.12 0.34C11.2 1.02 13.45 2.47 15.77 4.7C15.8 4.72 15.82 4.76 15.82 4.8V14.21C15.82 14.25 15.81 14.28 15.78 14.31C15.74 14.35 12.2 17.98 9.11 19.42C9.08 19.44 9.04 19.45 9.0 19.45ZM2.5 14.11C3.14 14.74 6.28 17.74 9.0 19.09C11.72 17.74 14.86 14.74 15.5 14.11V4.93C13.28 2.8 11.14 1.4 9.0 0.72C6.86 1.4 4.72 2.8 2.5 4.93V14.11Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8 5.6L3.8 13.7C3.8 13.7 6.2 16.2 8.4 17.4L8.4 9.4C8.4 9.4 6.3 8.1 3.8 5.6Z",
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.18,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 7.2,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65 7.75L4.05 8.1L4.8 7.35",
    stroke: "#231F20",
    strokeWidth: 0.22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 7.5,
    width: 2.6,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 9,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65 9.55L4.05 9.9L4.8 9.15",
    stroke: "#231F20",
    strokeWidth: 0.22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 9.3,
    width: 2.2,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 10.8,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 11.1,
    width: 2.8,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 7.2,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85 7.75L10.25 8.1L11.0 7.35",
    stroke: "#231F20",
    strokeWidth: 0.22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7.5,
    width: 2.6,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 9,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85 9.55L10.25 9.9L11.0 9.15",
    stroke: "#231F20",
    strokeWidth: 0.22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9.3,
    width: 2,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 10.8,
    width: 1.6,
    height: 1.1,
    rx: 0.15,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.1,
    width: 2.4,
    height: 0.5,
    rx: 0.12,
    fill: "#231F20",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.1L9.0 8.0L14.5 5.1",
    stroke: "#231F20",
    strokeWidth: 0.18,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.0L17.5 4.5L20.5 3.0L23.5 4.5L23.5 7.0L20.5 8.5L17.5 7.0Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.0L17.5 4.5",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 7.0L23.5 4.5",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.0L20.5 8.5L23.5 7.0",
    stroke: "#231F20",
    strokeWidth: 0.22,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.5L17.5 12.5L20.5 14.0L20.5 8.5L17.5 7.0L17.5 4.5Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4.5L23.5 12.5L20.5 14.0L20.5 8.5L23.5 7.0L23.5 4.5Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.5L20.5 14.0L23.5 12.5",
    stroke: "#231F20",
    strokeWidth: 0.22,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.12C20.46 14.12 20.42 14.11 20.39 14.09L17.39 12.59C17.34 12.56 17.31 12.51 17.31 12.46V4.46C17.31 4.42 17.33 4.38 17.37 4.36L20.37 2.86C20.43 2.82 20.57 2.82 20.63 2.86L23.63 4.36C23.67 4.38 23.69 4.42 23.69 4.46V12.46C23.69 12.51 23.66 12.55 23.62 12.58L20.62 14.08C20.59 14.11 20.55 14.12 20.5 14.12ZM17.57 12.35L20.5 13.84L23.43 12.35V4.57L20.5 3.08L17.57 4.57V12.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 6.6L18.3 5.2L20.5 4.1L22.7 5.2L22.7 6.6L20.5 7.7L18.3 6.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.82C20.46 7.82 20.42 7.81 20.39 7.79L18.19 6.69C18.14 6.66 18.11 6.61 18.11 6.56V5.16C18.11 5.12 18.13 5.08 18.17 5.06L20.37 3.96C20.43 3.92 20.57 3.92 20.63 3.96L22.83 5.06C22.87 5.08 22.89 5.12 22.89 5.16V6.56C22.89 6.61 22.86 6.65 22.82 6.68L20.62 7.78C20.59 7.81 20.55 7.82 20.5 7.82ZM18.37 6.45L20.5 7.52L22.63 6.45V5.27L20.5 4.2L18.37 5.27V6.45Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 7.7L19.8 13.5L21.2 13.5L21.2 7.7L19.8 7.7Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 13.2L19.2 14.5L21.8 14.5L21.8 13.2L19.2 13.2Z",
    fill: "#FCB813",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.5L20.5 17.5",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 18.2,
    rx: 1.8,
    ry: 0.85,
    fill: "#FCB813",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 17.9,
    rx: 1.8,
    ry: 0.85,
    fill: "#FCB813",
    stroke: "#231F20",
    strokeWidth: 0.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 17.9,
    rx: 0.55,
    ry: 0.28,
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5L17.3 9.0",
    stroke: "#231F20",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeDasharray: "0.55 0.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 3.5L7.6 5.0L8.8 4.7L8.1 6.3",
    stroke: "#F26F21",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_ce_002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceEngine);
export default __webpack_public_path__ + "static/media/Compliance_Engine.6420dad1f1731ed0bc825fe244f859e0.svg";
export { ForwardRef as ReactComponent };